import { FEATURES } from '@/constants/features';
import { canAccessFeature } from '@/utils/access';

export function canUseAgentPopup(user) {
  return !!user && canAccessFeature(FEATURES.MODULE_AGENT);
}
